







import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import TransitionExpand from '@/components/ui/TransitionExpand.vue';

@Component({
  components: {
    TransitionExpand,
  },
})
export default class CodeExampleSource extends Vue {
  @Prop({ default: false }) isMobile: boolean;
}
